module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("优选CRM用户注册")]), _vm._v(" "), _c('div', [_c('group', [_c('x-input', {
    attrs: {
      "title": "手机号码"
    },
    on: {
      "on-blur": _vm.telvaite
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  }), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "primary",
      "action-type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sureClick($event)
      }
    }
  }, [_vm._v("提 交")])], 1), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "time": 1200,
      "width": "18em",
      "is-show-mask": "",
      "text": _vm.toastTxt,
      "position": "middle"
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6773678","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/rkw/yxcrmregister.vue
// module id = Mp7u
// module chunks = 5